var DropdownSimpleXdmDefinitionBuilder = /** @class */ (function () {
    function DropdownSimpleXdmDefinitionBuilder(dropdownProvider) {
        if (!dropdownProvider) {
            throw new Error('dropdownProvider is not defined');
        }
        this.dropdownProvider = dropdownProvider;
    }
    DropdownSimpleXdmDefinitionBuilder.prototype.buildSimpleXdmDefinition = function () {
        return {};
    };
    return DropdownSimpleXdmDefinitionBuilder;
}());
export { DropdownSimpleXdmDefinitionBuilder };
//# sourceMappingURL=DropdownSimpleXdmDefinitionBuilder.js.map